import React, { useState, useEffect } from "react";
import { Phone, Menu, X } from "lucide-react";

const NAV = [
  { label: "Services", href: "#services" },
  { label: "Book", href: "#booking" },
  { label: "Reviews", href: "#reviews" },
  { label: "About", href: "#about" },
];

export default function Header() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      data-testid="site-header"
      className={`fixed top-0 inset-x-0 z-50 transition-all duration-300 ${
        scrolled
          ? "bg-zinc-950/80 backdrop-blur-2xl border-b border-zinc-800"
          : "bg-transparent"
      }`}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-16 md:h-20">
          <a href="#top" className="flex items-center gap-2.5" data-testid="logo-link">
            <div className="h-9 w-9 rounded-lg bg-cyan-400 flex items-center justify-center shadow-[0_0_20px_rgba(34,211,238,0.4)]">
              <span className="text-zinc-950 font-black text-lg">B</span>
            </div>
            <div className="leading-tight">
              <div className="font-black text-base tracking-tight">B&amp;B</div>
              <div className="text-[10px] uppercase tracking-[0.2em] text-cyan-400 font-bold">Auto Detailing</div>
            </div>
          </a>

          <nav className="hidden md:flex items-center gap-8">
            {NAV.map((n) => (
              <a
                key={n.href}
                href={n.href}
                data-testid={`nav-${n.label.toLowerCase()}`}
                className="text-sm font-medium text-zinc-400 hover:text-cyan-400 transition-colors"
              >
                {n.label}
              </a>
            ))}
          </nav>

          <div className="flex items-center gap-3">
            <a
              href="tel:+17079090231"
              data-testid="header-call-btn"
              className="hidden sm:inline-flex items-center gap-2 px-4 py-2 rounded-full border border-zinc-700 text-zinc-200 text-sm font-semibold hover:border-cyan-400 hover:text-cyan-400 transition-all"
            >
              <Phone className="h-4 w-4" />
              (707) 909-0231
            </a>
            <a
              href="#booking"
              data-testid="header-book-btn"
              className="hidden md:inline-flex items-center px-5 py-2 rounded-full bg-cyan-400 text-zinc-950 text-sm font-bold hover:bg-cyan-300 transition-all shadow-[0_0_20px_rgba(34,211,238,0.3)] hover:shadow-[0_0_30px_rgba(34,211,238,0.6)]"
            >
              Book Now
            </a>
            <button
              onClick={() => setOpen(!open)}
              className="md:hidden p-2 text-zinc-200"
              aria-label="Menu"
              data-testid="mobile-menu-btn"
            >
              {open ? <X className="h-6 w-6" /> : <Menu className="h-6 w-6" />}
            </button>
          </div>
        </div>

        {open && (
          <div className="md:hidden pb-4 border-t border-zinc-800 pt-4 space-y-3" data-testid="mobile-nav">
            {NAV.map((n) => (
              <a
                key={n.href}
                href={n.href}
                onClick={() => setOpen(false)}
                className="block text-zinc-300 hover:text-cyan-400 py-2 font-medium"
              >
                {n.label}
              </a>
            ))}
            <a
              href="#booking"
              onClick={() => setOpen(false)}
              className="block text-center bg-cyan-400 text-zinc-950 font-bold py-3 rounded-full mt-2"
              data-testid="mobile-book-btn"
            >
              Book Now
            </a>
          </div>
        )}
      </div>
    </header>
  );
}
